module.exports = __webpack_public_path__ + "img/Download.35dd4b72.svg";